import AiTypes from './types';

const initialState = {
  sendingChat: false,
  loadingSampleQueries: true,
  sampleQuries: [],
  chatHistory: [],
  error: null,
};

function aiReducer(state = initialState, { type, payload }) {
  switch (type) {
    case AiTypes.FETCH_SAMPLE_QUERIES_START:
      return {
        ...state,
        loadingSampleQueries: true,
      };
    case AiTypes.FETCH_SAMPLE_QUERIES_SUCCESS:
      return {
        ...state,
        loadingSampleQueries: false,
        sampleQuries: payload,
      };
    case AiTypes.FETCH_SAMPLE_QUERIES_FAILURE:
      return {
        ...state,
        loadingSampleQueries: false,
        error: payload,
      };

    case AiTypes.FETCH_AI_RESPONSE_START:
      return {
        ...state,
        sendingChat: true,
      };
    case AiTypes.FETCH_AI_RESPONSE_SUCCESS:
      return {
        ...state,
        sendingChat: false,
        chatHistory: [...state.chatHistory, payload],
      };
    case AiTypes.FETCH_AI_RESPONSE_FAILURE:
      return {
        ...state,
        sendingChat: false,
        error: payload,
      };

    case AiTypes.UPDATE_CHATHISTORY:
      return {
        ...state,
        chatHistory: [...state.chatHistory, payload],
      };

    case AiTypes.RESET_STATE:
      return {
        ...state,
        sendingChat: false,
        loadingSampleQueries: false,
        sampleQuries: [],
        chatHistory: [],
        error: null,
      };
    default:
      return state;
  }
}

export default aiReducer;
